/*
 * Copyright (c) 2023 Bolmate B.V.
 */

import {ChangeFunction, Switch} from '@dvrd/dvr-controls';
import React, { useMemo } from 'react';
import {COLOR_BLUE_BOLMATE} from "../../../util/constants";

interface Props {
    value: boolean;
    onChange: ChangeFunction<boolean>;
    trackColor?: string;
    baseColor?: string;
    labels?: string[];
    className?: string;
    labelClassName?: string;
    disabled?: boolean;
    activeGreen?: boolean;
    activeRed?: boolean;
    mainLabel?: string;
    offTrackColor?: string;
}

export default function BolmateSwitch(props: Props) {
    const {
        value, onChange, labels, labelClassName, className, disabled, trackColor, baseColor, activeGreen,
        mainLabel, activeRed, offTrackColor
    } = props;
    const _trackColor = useMemo(() => {
        if(trackColor?.length) return trackColor;
        else if (!value && offTrackColor?.length) return offTrackColor;
        if(!value) return 'color-gray-4';
        if(activeRed) return 'red';
        if(activeGreen) return 'color-green-whatsapp';
        return COLOR_BLUE_BOLMATE;
    }, [activeGreen, activeRed, value, trackColor, offTrackColor]);

    return (
        <Switch value={value} onChange={onChange} labels={labels} labelClass={labelClassName}
                containerClass={className} disabled={disabled} trackColor={_trackColor}
                baseColor={baseColor ?? 'white'} mainLabel={mainLabel}/>
    )
}